import * as constants from './constants';

const loadSupportContacts = () => ({
  type: constants.LOAD_SUPPORT_CONTACTS
});

export { loadSupportContacts };
